import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const userWorkspaceMenuRegistry = {
    personalize_userWorkspace: {
        label: "User Workspace",
        link: PAGE_URL.USER_WORKSPACE_PAGE,
        key: PAGE_URL.USER_WORKSPACE_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default userWorkspaceMenuRegistry;
